import { gql } from '@apollo/client';
import { PROPERTY_BASIC_DATA_FRAGMENT } from 'graphql/property/fragments';
import { SCOOPS_BASIC_RESULTS_DATA_FRAGMENT } from 'graphql/scoops/fragments';
import { USER_BASIC_FIELDS, ID_NAME_FIELDS } from 'graphql/common/fragments';

export const GET_SCOOPS_QUERY = gql`
  query getScoops($search: ScoopSearchInput) {
    scoops(search: $search) {
      totalPages
      currentPage
      results {
        ...scoopsBasicResultsData
      }
    }
  }
  ${SCOOPS_BASIC_RESULTS_DATA_FRAGMENT}
`;

export const GET_SCOOPS_WITH_PROPERTY_DATA_QUERY = gql`
  query getScoops($search: ScoopSearchInput) {
    scoops(search: $search) {
      totalPages
      currentPage
      results {
        ...scoopsBasicResultsData
        properties {
          ...propertyBasicDataFragment
        }
      }
    }
  }
  ${PROPERTY_BASIC_DATA_FRAGMENT}
  ${SCOOPS_BASIC_RESULTS_DATA_FRAGMENT}
`;

export const GET_SCOOP_CATEGORIES_QUERY = gql`
  query scoopCategories {
    scoopCategories {
      ${ID_NAME_FIELDS}
      type
    }
  }
`;

export const GET_SCOOP_COMMENTS_QUERY = gql`
  query scoopComments($scoopId: Int!) {
    scoopComments(scoopId: $scoopId) {
      id
      user {
        ${USER_BASIC_FIELDS}
      }
      userId
      scoopId
      comment
      createdAt
      updatedAt
    }
  }
`;

export const GET_SCOOP_MEDIA = gql`
  query getScoopMedia($scoopId: Int!) {
    mediaScoop(scoopId: $scoopId) {
      id
      type
      url
      width
      height
      category {
        ${ID_NAME_FIELDS}
        attachmentType
      }
    }
  }
`;
